import { Component, ElementRef, EventEmitter, HostBinding, Input, Output, ViewChild } from '@angular/core';
import { DisplayableImageContentTypes } from '../../constants-and-enums/image-types';
import { getHeroFileIcon } from 'src/app/shared/utils';

@Component({
    standalone: false,
    selector: 'app-document-upload',
    templateUrl: './document-upload.component.html',
    styleUrls: ['./document-upload.component.scss']
})
export class DocumentUploadComponent {
    @HostBinding('class') hostClass = 'block bg-base-100 h-full';
    @Input() buttonText: string;
    @Input() multi = true;
    @Input() onlyImages = false;

    @Output() filesSelected: EventEmitter<File[]> = new EventEmitter<File[]>();

    files: File[] = [];

    filePreviews = new Map<string, any>();

    @ViewChild('fileDropRef', { static: false }) fileDropEl: ElementRef;

    public clear(): void {
        this.files = [];
        this.filePreviews = new Map<string, any>();
        this.filesSelected.emit([]);
    }

    getDocumentExtension(document: File): string {
        return document?.name.split('.').slice(-1).join('');
    }

    isDisplayableImage(file: File): boolean {
        return DisplayableImageContentTypes.includes((file as Blob)?.type);
    }

    onFilesSelected($event): void {
        if (this.multi) {
            const newFiles = Array.from($event) as File[];

            this.files.push(...newFiles);
            this.filesSelected.emit(this.files);
        } else {
            const reader = new FileReader();
            reader.readAsDataURL($event.item(0));
            reader.onload = () => {
                this.filePreviews.set($event.item(0)?.name, reader.result);
            };

            this.files.splice(0);
            this.files.push($event.item(0));
            this.filesSelected.emit(this.files);
        }

        // Clearing needed to allow selecting the same file twice
        // Otherwise, it's not possible to remove a file and select it again
        if (this.fileDropEl?.nativeElement?.value) {
            this.fileDropEl.nativeElement.value = '';
        }
    }

    onSelectClick(): void {
        this.fileDropEl.nativeElement.click();
    }

    removeFile(file: File): void {
        const index = this.files?.indexOf(file) ?? -1;
        this.files.splice(index, 1);
        this.filePreviews.delete(file.name);
        this.filesSelected.emit(this.files);
    }

    protected readonly getHeroFileIcon = getHeroFileIcon;
}
